// TODO: Material num short
// TODO: Add confidence.
// TODO: Add ranking.
import { Bar } from "react-chartjs-2";
// import annotationPlugin from "chartjs-plugin-annotation";

// Chart.register(annotationPlugin);

interface VerticalBarInputs {
  dataI: any;
  swapElement:any;
  toReplace :any;
}

const VerticalBar = (props: VerticalBarInputs) => {
  const dataI = props.dataI;
  let materials: any[] = [];
  for (let mat of dataI.curr) {
    materials.push({
      ...mat,
      color: "gray",
      material_num_short: mat.material_num.replace("000000000000", ""),
    });
  }

  for (let mat of dataI.rmats) {
    let found = materials.find((v) => v.material_num.replace("000000000000", "") === mat.material_num.replace("000000000000", ""));

    if (!found) {
      materials.push({
        ...mat,
        color: "purple",
        recoSource: `Recommendation (${mat.reco_source=='lf'?'FSV':'Convenience'})`,
        material_num_short: mat.material_num.replace("000000000000", ""),
        tradeSetting : (dataI.info.convenience_percentage || dataI.info.fsv_percentage)? `(${mat.reco_source=='lf'?`${dataI.info.fsv_percentage}% of ${mat.primeryEaches}` :`${dataI.info.convenience_percentage}% of ${mat.primeryEaches}`})`:'',
      });
    }
  }

  for (let mat of dataI.allMats) {
    let found = materials.find((v) => v.material_num.replace("000000000000", "") === mat.material_num.replace("000000000000", ""));

    if (!found) {
      materials.push({
        ...mat,
        color: "orange",
        recoSource: `Machine Learning (${mat.reco_source=='lf'?'FSV':'Convenience'})`,
        material_num_short: mat.material_num.replace("000000000000", ""),
        tradeSetting : (dataI.info.convenience_percentage || dataI.info.fsv_percentage)? `(${mat.reco_source=='lf'?`${dataI.info.fsv_percentage}% of ${mat.primeryEaches}` :`${dataI.info.convenience_percentage}% of ${mat.primeryEaches}`})`:'',
      });
    }
  }

  materials.sort((a, b) => b.eaches - a.eaches);
  materials = materials.filter((v) => v.eaches > 0);

  const keys = materials.map((v: any) => {
    let desc: string = v.description;
    if (!desc) return v.material_num_short;
    if (desc.length > 15) desc = desc.substring(0, 15);

    return [`${v.material_num_short} ${desc}`];
  });

  const data = {
    labels: keys,
    datasets: [
      {
        label: "Predicted Avg. Eaches",
        data: materials.map((v: any) => v.eaches),
        backgroundColor: materials.map((v: any) => v.color),
        borderColor: "rgba(0, 0, 0, 0)",
        color: materials.map((v: any) => v.color),
        borderWidth: 1,
      },
    ],
  };
  const options: any = {
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            labelString: "Daily Volume",
            fontSize: 20,
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            maxRotation: 90,
            minRotation: 90,
          },
        },
      ],
    },
    legend: {
      display: false,
    },
    animation: false,
    tooltips: {
      callbacks: {
        title: (tooltipItem: any[]) => {
          let matNumShort = tooltipItem[0].label.split(" ")[0];
          let found = materials.find(
            (v: any) => v.material_num_short === matNumShort
          );

          return `${found.material_num_short} ${found.description}`;
        },
        label: (tooltipItem: any, data: any) => {
          let matNumShort = tooltipItem.label.split(" ")[0];
          let found = materials.find(
            (v: any) => v.material_num_short === matNumShort
          );
          if (!found) return "";
          if (found.recoSource) {
            return [
              `Reco Source: ${found.recoSource}`,
              `Predicted Volume: ${found.eaches} / Day ${found.tradeSetting}` ,
            ];
          }
          if (found.strategic) {
            return [
              `Source: Strategic Product`,
              `Predicted Volume: ${found.eaches} / Day`,
            ];
          }
          return [`Source: Current`, `Volume: ${found.eaches} / Day`];
        },
      },
      displayColors: false,
    },
    onClick: (e:any, element:any) => {
      if (element.length > 0) {
        var ind = element[0]?._model?.label;
         let materialNum = ind[0]?.split(" ")[0];
         
         
        
          let newMat;
         dataI?.allMats?.forEach(function(currentValue:any){
          
           if(materialNum === parseInt(currentValue.material_num).toString()){
            
            
            let data = `${parseInt(currentValue.material_num).toString()} - ${currentValue.description}`;
            let description = currentValue.description;
            let material_num = currentValue.material_num;
            let source = currentValue.source;

            newMat ={
              data,
              description,
              material_num,
              source
            }


           }
         })
          props.swapElement(props.toReplace, newMat);
      }
    }
  };

  return (
    <Bar
      type="bar"
      data={data}
      height={400}
      options={options}
      // plugins={[annotationPlugin] as any}
    />
  );
};

export default VerticalBar;
